var styleDataHash = "0026cc31";
const injectCss = (() => {
  var css = `.V4t-c{display:flex;margin:0}.FfkuY{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));font-size:inherit;font-weight:inherit;line-height:28px;margin:0;max-width:270px;overflow:hidden;padding:0 4px;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.FfkuY:hover{text-decoration:underline}.FfkuY:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.FfkuY.OovqH{line-height:32px}.xpp9K{background:transparent;border:0}.xpp9K:hover{cursor:pointer}@supports not (contain:inline-size){@media only screen and (max-width:480px){.FfkuY{max-width:160px}}}@container (width < 480px){.FfkuY{max-width:160px}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var url_link_button_default = {
  "toolbarUrlContainer": "V4t-c",
  "toolbarUrl": "FfkuY",
  "isMobile": "OovqH",
  "toolbarUrlAnchor": "xpp9K"
};
export {
  url_link_button_default as default,
  injectCss
};
//# sourceMappingURL=url-link-button-scss.js.map
